import React, { useEffect, useState } from 'react';
import { FaShieldAlt } from 'react-icons/fa';
import api from '../../api/apiClient';

const OrgPrivacyPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentVersion, setCurrentVersion] = useState(null);

  useEffect(() => {
    const fetchPrivacy = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.privacy.listVersions();
        if (response.data?.success) {
          setCurrentVersion(response.data.data?.currentVersion || null);
        } else {
          setError('Failed to load Privacy Policy');
        }
      } catch (err) {
        console.error('OrgPrivacyPage error:', err);
        setError('Failed to load Privacy Policy');
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacy();
  }, []);

  return (
    <div className="p-3 sm:p-6 md:p-8 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 min-h-screen">
      <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
          <div>
            <h3 className="fw-bold mb-0 text-xl sm:text-2xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
              Privacy Policy
            </h3>
            <p className="text-sm text-gray-600 mt-1">View the current privacy policy for your organization.</p>
          </div>
        </div>

        {loading && (
          <div className="text-center py-6">
            <div className="animate-spin h-8 w-8 border-4 border-purple-600 border-t-transparent rounded-full mx-auto"></div>
          </div>
        )}

        {error && !loading && (
          <div className="mb-3 p-3 rounded bg-red-50 border border-red-100 text-red-700">{error}</div>
        )}

        {!loading && !error && !currentVersion && (
          <div className="text-center py-6">
            <FaShieldAlt className="text-gray-300 mb-3" style={{ fontSize: '3rem' }} />
            <p className="text-gray-500">No Privacy Policy has been published yet for this organization.</p>
          </div>
        )}

        {!loading && !error && currentVersion && (
          <>
            <div className="mb-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
              <div className="text-sm text-gray-600">
                <span className="font-semibold">Version {currentVersion.version}</span>
                {currentVersion.published_at && (
                  <>
                    {' '}· Published on {new Date(currentVersion.published_at).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </>
                )}
              </div>
            </div>
            <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: currentVersion.content || '' }} />
          </>
        )}
      </div>
    </div>
  );
};

export default OrgPrivacyPage;
